import { render, staticRenderFns } from "./JoinHouseMateGroup.vue?vue&type=template&id=226c6dbf&class=tw-flex%20tw-min-h-%5B670px%5D%20tw-flex-%5B1_0_0%5D%20tw-flex-col%20tw-items-center%20tw-gap-6%20tw-self-stretch%20tw-overflow-visible%20tw-p-4"
import script from "./JoinHouseMateGroup.vue?vue&type=script&lang=js"
export * from "./JoinHouseMateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports